module.exports = "\n<div *ngFor=\"let uniqueTreeName of uniqueTreeNames; let i = index \">\n  <span class=\"tag\">\n    <span *ngFor=\"let region of regionsPerTreeName[i]\">{{region}}</span>\n  </span>\n\n  <a href=\"{{uniqueUrls[i]}}\">{{uniqueTreeName}}</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_component/searchresult/searchresult.component.html
// module id = ./src/app/_component/searchresult/searchresult.component.html
// module chunks = main